import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Empty, Spin } from "antd";
import MediaQuery from "react-responsive";

import API from "scripts/api";

import { Modals } from "scripts/settings";
import Resources from "scripts/resources";

import LoadMore from "components/loadmore";
import ManageModal from "modals/manage-job";
import BannerModal from "modals/ad-banner";
import LadderModal from "modals/ladder";
import SpecialModal from "modals/special-jobs";
import SubscriptionModal from "modals/subscription";

const Component = ({ user }) => {
	const initialState = {
		list: [],
		page: 1,
	};
	const [state, setState] = useState(initialState);
	const { list, loaded, loading, loadMore, page, selected } = state;
	const { pathname, search } = useLocation();
	const navigate = useNavigate();

	const handleData = (params) => {
		if (!loading) {
			setState((prevState) => ({ ...prevState, loading: true }));

			params.pageSize = 12;

			API.profile
				.myJobs({
					pageSize: process.env.REACT_APP_PAGE_SIZE,
					page: params.page,
				})
				.then(({ data, meta: { currentPage, perPage, total } }) => {
					setState((prevState) => ({
						...prevState,
						loaded: true,
						loading: false,
						loadMore: total > currentPage * perPage,
						list: [...list, ...data],
						page: currentPage,
					}));
				})
				.catch(() => {
					setState((prevState) => ({ ...prevState, loading: false }));
				});
		}
	};

	const handleManage = (selected) => {
		setState((prevState) => ({ ...prevState, selected }));

		navigate(`${pathname}${search}#${Modals.MANAGE}`);
	};

	const handleLoadmore = () => {
		handleData({ page: page + 1 });
	};

	const componentDidMount = () => {
		handleData({});
	};

	useEffect(componentDidMount, []);

	return loaded ? (
		<div className="panel-jobs">
			{loaded ? (
				list.length ? (
					<>
						<ul className="row">
							{list.map(
								({ category, cover, id, isPublished, slug, status, title }) => (
									<li
										className="col-12 col-md-6 col-xl-4"
										key={id}
									>
										<MediaQuery minWidth={992}>
											<div className="spa-job-card">
												<div className="card">
													<Link
														to={`/job/${slug}`}
														className="cover"
													>
														<img
															src={cover?.url}
															alt={title}
															className="bk-aspect"
														/>
													</Link>

													<h3 className="name">
														<Link to={`/job/${slug}`}>{title}</Link>
													</h3>
													<h5 className="category">
														<Link to={`/jobs?category=${category?.slug}`}>
															<img
																src={category?.icon}
																alt={category?.title}
															/>
															{category?.title}
														</Link>
													</h5>

													{/* add pending later when added */}
													<div className="condition colored-text">
														<span className="confirm">{Resources.status}:</span>
														<span
															className={`status${
																status.en === "approved"
																	? " green"
																	: status.en === "pending"
																	? " blue"
																	: status.en === "neutral"
																	? " orange"
																	: status.en === "rejected"
																	? " red"
																	: " red"
															}`}
														>
															{status.fa}
														</span>
													</div>
													<button
														onClick={() => handleManage({ slug, title })}
														className="manage"
													>
														{`${Resources.manage} ${Resources.job}`}
													</button>
												</div>
											</div>
										</MediaQuery>
										<MediaQuery maxWidth={992}>
											<div
												className="pwa-job-card"
												onClick={() => handleManage({ slug, title })}
											>
												<span
													className="cover"
													style={{ backgroundImage: `url(${cover?.url})` }}
												/>
												<h3 className="title">{title} </h3>
												<span className="category">
													<img
														src={category?.icon}
														alt={category?.title}
													/>
													{category?.title}
												</span>
												<div className="publication">
													<span>{Resources.status}: </span>
													<span
														className={`status${
															isPublished?.bool ? " public" : " not-public"
														}`}
													>
														{isPublished.fa}
													</span>
												</div>
												<div
													className={`condition${
														status?.en === "neutral"
															? " neutral"
															: status?.en === "pending"
															? " pending"
															: status?.en === "approved"
															? " approved"
															: "rejected"
													}`}
												>
													<span className={`status`}>{status?.fa}</span>
												</div>
											</div>
										</MediaQuery>
									</li>
								)
							)}
						</ul>
						{loadMore && (
							<LoadMore
								onScreen={handleLoadmore}
								loading={loading}
							/>
						)}
						<BannerModal />
						<LadderModal data={selected} />
						<ManageModal data={selected} />
						<SpecialModal />
						<SubscriptionModal data={selected} />
					</>
				) : (
					<Empty />
				)
			) : (
				<Spin />
			)}
		</div>
	) : (
		<Spin className="page-loading" />
	);
};

export default connect((state) => {
	return {
		user: state.user,
	};
})(Component);
